module.exports = __webpack_public_path__ + "static/FY_2021_Financial Reporting_Audit_Report-fdf670515499e309f5ce0b8ff58bb71a.pdf";